export default __webpack_public_path__ + "static/media/94739EDC-5DC7-42A1-B202-95DDEFDD8FF5_1_201_a.67438934.jpg";